module.exports = __webpack_public_path__ + "static/media/dinner2.dadb7870.png";